module.exports = {
    APP_NAME: "Elite Blue Technologies",
    HEADER_TYPE: "absolute",
}